import React, { useState } from "react";
import Select from "react-select";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ICategory } from "../../types";
import { updateCategoryByAdmin } from "../../services/categoryService";
import { ClipLoader } from "react-spinners";

interface EditCategoryModalProps {
  category: ICategory;
  onClose: () => void;
}

const EditCategoryModal = ({ category, onClose }: EditCategoryModalProps) => {
  const [name, setName] = useState(category?.name || "");
  const [isFeatured, setIsFeatured] = useState(category?.isFeatured || false);

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => updateCategoryByAdmin(category._id, { name, isFeatured }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["categories"] });
      onClose();
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate();
  };

  return (
    <div className="fixed inset-0 p-2 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl mb-4">Edit Category</h2>
        <form onSubmit={handleSubmit}>
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Category Name
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full mt-1 p-2 border rounded-md"
              disabled={mutation.isPending}
            />
          </label>

          <label className="block mb-2 text-sm font-medium text-gray-700">
            Featured Category
            <Select
              value={{
                value: isFeatured,
                label: isFeatured ? "True" : "False",
              }}
              onChange={(selectedOption) =>
                setIsFeatured(selectedOption?.value || false)
              }
              options={[
                { value: true, label: "True" },
                { value: false, label: "False" },
              ]}
              isDisabled={mutation.isPending}
            />
          </label>

          <div className="flex justify-end mt-4">
            <button
              type="button"
              className="px-4 py-2 text-rose-500 rounded-lg text-sm"
              onClick={onClose}
              disabled={mutation.isPending}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm rounded-lg border ml-2 flex items-center justify-center"
              disabled={mutation.isPending}
            >
              {mutation.isPending ? <ClipLoader size={20} /> : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCategoryModal;
